import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://api.golflists.com';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  multiTab: false, //this may be obsolete now
});
